<template>
    <div>
       <div :class="isMobile?'contBoxB':'contBox'">
           <div class="clearfix">
            <span class="fl mr5" :class="isMobile?'ml10':''">当前位置:</span>
            <el-breadcrumb class="fl" style="margin-top: 4px;font-size: 15px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>党建园地</el-breadcrumb-item>
            </el-breadcrumb>
           </div>
           <div :class="isMobile?'partyBoxB':'partyBox'">
                <div class="partyLeft" v-if="!isMobile">
                    <div class="tabbox">
                        <p :class="active==102101?'czhus':''" @click="changeType(102101)"><i class="el-icon-caret-right"></i>党建文件</p>
                        <p :class="active==102102?'czhus':''" @click="changeType(102102)"><i class="el-icon-caret-right"></i>党建活动</p>
                    </div>
                </div>
                <div v-if="isMobile" class="partyLeftB">
                    <div class="tabbox">
                        <p :class="active==102101?'czhus':''" @click="changeType(102101)"><i class="el-icon-caret-right"></i>党建文件</p>
                        <p :class="active==102102?'czhus':''" @click="changeType(102102)"><i class="el-icon-caret-right"></i>党建活动</p>
                    </div>
                </div>
                <div :class="isMobile?'partyRightB':'partyRight'">
                    <div class="partyData" v-if="partyList.length!=0">
                        <div class="clearfix partyList" v-for="(item,index) in partyList" :key="index" @click="lookInfo(item.NewsGuid)">
                            <template v-if="!isMobile">
                                <span class="fl point"></span>
                                <span class="fl overh partyT">{{item.Title}}</span>
                                <span class="fr partime">{{item.AddTime | timeToDate}}</span>
                            </template>
                            <template v-else>
                                <div class="clearfix">
                                    <span class="fl point"></span>
                                    <span class="fl overh partyTB">{{item.Title}}</span>
                                </div>
                                <p class="partime mt10 textr">{{item.AddTime | timeToDate}}</p>
                            </template>
                        </div>
                    </div>
                    <el-empty v-if="partyList.length==0" description="暂无数据"></el-empty>
                    <el-pagination v-if="partyList.length!=0" class="textc mt10" background layout="prev, pager, next" :total="total" @current-change="handelPage"></el-pagination>
                </div>
           </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                active:'',
                partyList:[],
                total:20,
                form:{
                    cataCode:102101,
                    pageIndex:1,
                    pageSize:10
                }
            }
        },
        watch:{
            $route(){
                setTimeout(()=>{
                    this.changeType(this.$route.query.type)
                },50)
            }
        },
        methods:{
            // 切换党建类型
            changeType(type){
                this.active = type
                this.form.cataCode =type
                this.getListData()
            },

            //获取列表数据
            getListData(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataTwo',
                    method: 'get',
                    data:{
                        ...this.form
                    }
                }).then((data) => {
                   this.total = data.TotalSum
                   this.partyList = data.Data
                })
            },

            //查看详情
            lookInfo(id){
                this.$router.push({
                    path:'/partyBuild/info?id='+id+'&type='+this.active
                })
            },

            //切换分页
            handelPage(val){
                this.form.pageIndex = val
                this.form.cataCode = this.active
                this.getListData()
            }
        },
        mounted(){
            var type = this.$route.query.type||102101
            this.changeType(type)
            
        }
    }
</script>

<style scoped>
    .partyBox{
        display: flex;
        justify-content: space-between;
        background: none;
    }
    .partyLeft{
        width: 240px;
        min-height: 600px;
        background: #fff url(~@/assets/home/beijing.jpeg) no-repeat;
        background-position: right;
        background-size: auto 100%;
    }
    .partyLeft .tabbox{
        background-color: #fff;
    }
    .partyLeft p{
        padding: 20px;
        cursor: pointer;
        border-bottom: 1px dashed #e0e0e0;
    }
    .partyLeftB .tabbox{
        display: flex;
        justify-content: space-around;
        background-color: #fff;
        padding: 15px 0;
    }
    .partyRight{
        width: calc(100% - 270px);
        background-color: #fff;
        padding-bottom: 10px;
    }
    .partyBoxB{
        background: none;
    }
    .partyRightB{
        width: 100%;
        margin-top: 20px;
        background-color: #fff;
        padding-bottom: 10px;
    }
</style>